/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Component } from 'react';
import colors from '../colors';

export default class Link extends Component {
  render() {
    const { onClick, children } = this.props;
    return (
      <div
        className={this.props.className}
        css={css(
          `
          color: ${colors.highlight};
          font-size: 12px;
          cursor: pointer;
        `,
          this.props.css
        )}
        onClick={onClick}
      >
        {children}
      </div>
    );
  }
}
